import { render, staticRenderFns } from "./AddFields.vue?vue&type=template&id=68123068&scoped=true"
import script from "./AddFields.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFields.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddFields.vue?vue&type=style&index=0&id=68123068&prod&lang=scss&scoped=true"
import style1 from "./AddFields.vue?vue&type=style&index=1&id=68123068&prod&lang=scss"
import style2 from "./AddFields.vue?vue&type=style&index=2&id=68123068&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68123068",
  null
  
)

export default component.exports